import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { Common } from 'src/app/common';
import { CommunicationEventService } from 'src/app/services/communication-event.service';
import {
	IrtwadModel,
	RtwadImagePath,
	RtwadService,
	rtwadPath,
} from 'src/app/services/rtwad.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-rtwad-form',
	templateUrl: './rtwad-form.component.html',
	styleUrls: ['./rtwad-form.component.scss'],
})
export class RtwadFormComponent implements OnDestroy, OnInit {
	currentUser: any;
	isOperator = false;
	editorConfig: AngularEditorConfig = Common.EditotConfig_Operator;
	imagePath = RtwadImagePath;
	rtwadPath = rtwadPath;

	@Input() rtwadModel: IrtwadModel = {};
	@Input() isOperatorMode: boolean = false;

	constructor(
		private sharedService: SharedService,
		private route: ActivatedRoute,
		private toast: ToastrService,
		private rtwadService: RtwadService,
		private router: Router,
		private userService: UserService,
		private spinner: SpinnerService,
		private eventLog: CommunicationEventService,
	) {
		sharedService.me$.pipe(takeUntil(this.unsubscribe$)).subscribe(async () => {
			this.loadUser();
			await this.loadModel();
		});
	}

	loadUser() {
		this.currentUser = this.sharedService.me;
		if (!this.currentUser) return;
		this.isOperator = this.currentUser.IsOperator;
	}

	async loadModel() {
		const id = this.route.snapshot.params['id'];
		if (id)
			this.rtwadModel = this.isOperatorMode
				? await this.rtwadService.adminGetById(id)
				: await this.rtwadService.ownerGetById(id);
		else if (!this.rtwadModel.Phone && !this.isOperatorMode) {
			this.rtwadModel = {
				Phone: this.currentUser?.Username,
				ContactName: this.currentUser?.Name,
			};
		}
	}

	private unsubscribe$ = new Subject<void>();
	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	async ngOnInit() {
		await this.loadModel();
		this.isOperatorMode = this.isOperatorMode && this.isOperator;

		if (!this.isOperator) {
			if (this.rtwadModel.Id)
				this.eventLog.log(this.eventLog.actions.rtwad.owner.viewFormUpdate);
			else this.eventLog.log(this.eventLog.actions.rtwad.owner.viewFormNew);
		}
	}

	previewImageSrc?: string;
	images: File[] = [];
	onFileChange(files: File[]) {
		if (files?.length > 0) {
			this.images.push(...files);
			if (this.images?.length)
				Array.from(this.images).forEach((file) => this.previewImage(file));
		}
	}
	private previewImage(image: any) {
		var oFReader = new FileReader();
		oFReader.onload = (_) => ((<any>image)._dataUrl = _.target.result);
		oFReader.readAsDataURL(image);
	}

	toPay = this.userService.ReadyToWorkBasePrice;
	@ViewChild('paymentModal') paymentModal: NgxSmartModalComponent;
	async submitForm(form: NgForm) {
		if (form.invalid) return;
		this.rtwadModel = await this.rtwadService.save(
			this.rtwadModel,
			...this.images,
		);
		this.images = [];
		if (this.rtwadModel.Status == 'NotPaid') {
			this.paymentModal.open();
			this.eventLog.log(this.eventLog.actions.rtwad.owner.startPayment);
		} else this.toast.success('ذخیره شد.');
	}

	async pay(manualToken?: string) {
		this.spinner.show('payment');
		await this.userService.readytoworkPay(
			this.rtwadModel.Id,
			null,
			manualToken,
		);

		this.eventLog.log(this.eventLog.actions.rtwad.owner.sentToIPG);
	}

	async saveAdmin() {
		this.rtwadModel = await this.rtwadService.saveAdmin(
			this.rtwadModel,
			...this.images,
		);
		this.images = [];
		this.toast.success('ذخیره شد.');
	}

	async deleteRtwad() {
		if (!this.rtwadModel?.Id) return;

		const confirmDelete = confirm('آیا مطمئن هستید؟');
		if (!confirmDelete) return;

		try {
			const deletedAd = await this.rtwadService.softDelete(this.rtwadModel.Id);
			this.toast.success('با موفقیت حذف شد.');
		} catch (error) {
			console.error(error);
			this.toast.error('خطا در حذف');
		}
	}
}
